import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import localizedFormat from 'dayjs/plugin/localizedFormat'

dayjs.extend(relativeTime)
dayjs.extend(localizedFormat)

const DEFAULT_LOCALE = 'en'

const LOCALES = {
  en: async () => import('dayjs/locale/en'),
  fr: async () => import('dayjs/locale/fr'),
  de: async () => import('dayjs/locale/de'),
  es: async () => import('dayjs/locale/es'),
  it: async () => import('dayjs/locale/it'),
  pl: async () => import('dayjs/locale/pl'),
  pt: async () => import('dayjs/locale/pt'),
  ro: async () => import('dayjs/locale/ro'),
  ru: async () => import('dayjs/locale/ru'),
  tr: async () => import('dayjs/locale/tr'),
  cs: async () => import('dayjs/locale/cs'),
  hu: async () => import('dayjs/locale/hu'),
  nl: async () => import('dayjs/locale/nl'),
  vi: async () => import('dayjs/locale/vi'),
  uk: async () => import('dayjs/locale/uk'),
}

export async function loadLanguage(lang: string) {
  // $lang can be id or tl
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  const loadLocale = LOCALES[lang as keyof typeof LOCALES] ?? LOCALES[DEFAULT_LOCALE]

  if (lang !== DEFAULT_LOCALE) {
    await loadLocale()
  }

  return (...params: Parameters<typeof dayjs>) => dayjs(...params).locale(lang)
}

export default defineNuxtPlugin({
  name: 'date',
  dependsOn: ['language'],
  parallel: true,
  async setup({ $lang }) {
    const date = await loadLanguage($lang as string)
    return { provide: { date } }
  },
})
